(function($){

	var homeVideo = function(){
		var win = $(window);
		var header = $('#site-header');
		var videoTitle = $('#home-video-title');
		var videoContainer = $('#home-video-container');
		var theVideo = document.getElementById('home-video');

		$('.overlay-hover-trigger').on('click', function(e){
			e.stopPropagation();
			
			if( !theVideo.paused ){
				theVideo.pause();
			}
			else{
				videoContainer.addClass('vis');
				theVideo.play();

			}
		});

		$('.video-container').on('click', function(){
			if($(this).hasClass('vis')){
				// console.log('overlayclick');
				if( !theVideo.paused ){
					theVideo.pause();
				}
				else{
					theVideo.play();
				}
			}
		});


		var homeVideoScroll = function(){
			
			// var topTrigger = (videoContainer.offset().top - videoTitle.outerHeight() - header.outerHeight()) - win.scrollTop();
			// var topTrigger2 = (videoContainer.offset().top + videoContainer.outerHeight() - win.innerHeight()) - win.scrollTop();

			// // console.log(topTrigger2, win.scrollTop());

			// if( win.scrollTop() > 0 && (topTrigger < 0 || topTrigger2 < 0) && theVideo.currentTime > 1){
			// 	// videoContainer.addClass('vis');
			// 	theVideo.play();
			// }
			// else{
			// 	// videoContainer.removeClass('vis');
			// 	theVideo.pause();
			// }


			var topTrigger = (videoContainer.offset().top - win.innerHeight()) - win.scrollTop();
			var topTrigger2 = (videoContainer.offset().top + videoContainer.outerHeight()) - win.scrollTop();

			// console.log(topTrigger, topTrigger2, win.scrollTop());

			if( win.scrollTop() > 0 && topTrigger < 0 && topTrigger2 > 0 ){
				// videoContainer.addClass('vis');
				if(theVideo.currentTime > 1){
					theVideo.play();
				}
			}
			else{
				// videoContainer.removeClass('vis');
				theVideo.pause();
			}
		}
		optimizedScroll.add( homeVideoScroll );

		theVideo.addEventListener('ended',videoEnd,false);
		function videoEnd(){
			videoContainer.removeClass('vis');
			// theVideo.pause();
			theVideo.currentTime = 0;
		}
/*
		$('.overlay-hover-trigger').hover(function(){
			videoContainer.addClass('vis');
			theVideo.play();
		},
		function(){
			// videoContainer.removeClass('vis');
			// theVideo.pause();
			// theVideo.currentTime = 0;
		});*/


	}

	var expandableContent = function(){
		$('[data-action="expandable-content"]').on('click', function(e){
			e.stopPropagation();
			var target = $(this).parents('.expandable-section');
			$('.expandable-section').not(target).removeClass('open');
			target.toggleClass('open');
		});
	};

	var parkingTabs = function(){
		//tab switch
		$('[data-action="parking-tab"]').on('click', function(){
			var targetId = '#' + $(this).attr('data-target');

			$('.parking-tab').not(targetId).removeClass('active');
			$(targetId).addClass('active');

			$(targetId).find('.variation-nav > li:first-child > a').addClass('selected');
			$(targetId).find('.parking-variation:first-child').addClass('active');
		});

		//variation switch
		// $('[data-action="parking-variation"]').on('change', function(){
		// 	var targetId = '#' + $(this).attr('data-target');

		// 	$('.parking-variation').not(targetId).removeClass('active');
		// 	$(targetId).addClass('active');

		// });

		var variationLink = $('a[data-action="parking-variation"]');

		variationLink.on('click', function(e){
			e.preventDefault();
			var targetId = $(this).attr('href');
			variationLink.not(this).removeClass('selected');
			$(this).addClass('selected');

			$('.parking-variation').not(targetId).removeClass('active');
			$(targetId).addClass('active');

		});
	};

	var scrollToAnchor = function(){
		// $('.scroll-to-anchor, a[href^="#"]').on('click', function(e){
		$('.no-anchor').on('click', function(e){
			e.preventDefault();
		});
		$('.scroll-to-anchor').on('click', function(e){

			if($(this).hasClass('no-scroll')){
				return;
			}
			else if(this.hash){

				var hashTarget = $(this.hash);

				if( hashTarget.length ){
					e.preventDefault();
					var anchorPosition = hashTarget.offset().top;
					var finalPosition = anchorPosition - 100; //$('.site-header').outerHeight();
					$("html, body").animate({scrollTop: finalPosition}, 1000);

					$( 'body' ).removeClass( 'nav-open' );
				}
			}
		});
	};

	var spaceGallery = function(){
		// $('.space-gallery')
		
		var galleryMainImg = document.getElementById('gallery-main-img');
		
		$(document).on('click', '[data-action="gallery-img"]', function(e){
			e.preventDefault();
			var imgUrl = $(this).attr('data-target');
			galleryMainImg.style.backgroundImage = 'url(' + imgUrl + ')';
		});
	};

	var eventsSlider = function(){

		var filtered = false;

		// $('.events-slider').on('init', function(slick){
		// 	console.log('init');

		// 	// if(filtered == true){
		// 	// 	$('.events-slider').slick('slickUnfilter');
		// 	// 	filtered = false;
		// 	// }
		// 	$(this).find('.event').each(function(){
		// 		var cats = $(this).attr('data-cats');
		// 		// console.log(cats);
		// 		$(this).parents('.slick-slide').addClass(cats);
		// 	});
		// });

		$('.events-slider').slick({
			dots: false,
			// 'arrows': false,
			prevArrow: '.event-slider-nav-prev',
			nextArrow: '.event-slider-nav-next',
			slidesToShow: 4,
			slidesToScroll: 4,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 3
					}
				},
				{
					breakpoint: 800,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2
					}
				},
				{
					breakpoint: 640,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}
			]
		});
		

		$('.events-slider-filter-select').on('change', function(){
			var target = $(this).val();
			console.log(target);

			$('.events-slider').slick('slickUnfilter');

			if(target !== 'all'){
				var filterEl = $('.event.' + target).parents('.slick-slide');
				$('.events-slider').slick('slickFilter', filterEl);
			}
		});

	};

	var timelineSlider = function(){
		var $control = $('.split-imgs .control');
		var $leftContainer = $('.split-imgs .left-container');
		var $maskLayer = $('.split-imgs .mask-layer');
		var $rightLayer = $('.split-imgs .right-layer');
		var $leftLayer = $('.split-imgs .left-layer');


		var pct = 0.5;
		var rOpacity = (1-pct)+(1-pct);
		var lOpacity = pct*2;

		var draw = function() {
			var pctString = (pct * 100) + '%';
			$leftContainer.css('width', pctString);
			$maskLayer.css('width', pctString);
			$control.css('left', pctString);
			$leftLayer.width($rightLayer.width());
			
			//var mapNum = ((( pct - 0.1 ) * ( 0.85 - 0.5 ) / ( 0.9 - 0.1 ) + 0.5) * 100) + '%';
			var rTitlePos = ((($maskLayer.width() + (($rightLayer.width() - $maskLayer.width())/2)) / $rightLayer.width()) * 100) + '%';

			//$('.index-room').html(pct);
			
			rOpacity = pct > .5 ? (1-pct)+(1-pct) : 1;
			lOpacity = pct < .5 ? pct*2 : 1;
			
		};

		var onMove = function(e, obj) {
			var x = obj.pos.x;
			var parentWidth = obj.$el.parent().width();

			if (parentWidth !== 0) {
				var offset = 21 / parentWidth; // Offset for width of control
				pct = (x / parentWidth) + offset;
			}

			draw();
		};

		var init = function() {
			draw();
			$control.pep({
				place: false,
				moveTo: function(x, y) {
					var dir = x.charAt(0);
					var val = x.substring(2);
					var windowWidth = $control.parent().width();
					var pctChange = val / windowWidth;

					if (dir === '+') {
						pct = Math.min(pct + pctChange, 1);
					} else {
						pct = Math.max(pct - pctChange, 0);
					}

					draw();
				},
				shouldEase: false
			});
		};

		if ($control.is('*')) {
			init();
		}
	}

	var imgZoom = function(){
		// console.log('imgzoom');
		$('.imgzoom').magnify({
			// limitBounds: true,
			afterLoad: function() {
				// console.log('Magnification powers activated!');
			}
		});
	}

	$(document).ready(function(){
		if($('body').hasClass('home')){
			homeVideo();
		}
		expandableContent();
		spaceGallery();
		parkingTabs();
		eventsSlider();
		timelineSlider();
		scrollToAnchor();
		imgZoom();
	});

})(jQuery);